import { KeyboardEvent, useState } from "react";
import LoginApi from "../../../api/LoginApi";
import Api from "../../../api/Api";
import SessionService from "../../../services/session/SessionService";
import { ErrorMessage, FormItemInput, FormItemLabel, FormItemWrapper, FormSubmit, TitleForm, LoginDialogWrapper, LoginForm, LoginFormTitle, LoginFormTitleEn, LoginFormWrapper, LoginPicture, LoginWrapper } from "./Login.styled";
import {MobileOutlined , KeyOutlined, BankOutlined, UserOutlined} from "@ant-design/icons";
import { Input } from "antd";

interface LoginProps {
}

const Login: React.FC<LoginProps> = (props)=> {
    // state
    let [tenantName, setTenantName] = useState('');
    let [userName, setUserName] = useState('');
    let [password, setPassword] = useState('');
    let [error, setError] = useState('');

    // events
    let onTenantNameChange = (value: string)=> {
        setTenantName(value);
    };

    let onUserNameChange = (value: string)=> {
        setUserName(value);
    };

    let onPasswordChange = (value: string)=> {
        setPassword(value);
    }

    let onPasswordKeyDown = (e: KeyboardEvent)=> {
        if (e.key.toLowerCase() == 'Enter'.toLowerCase()) {
            login();
        }
    }

    let login = async ()=> {
        let loginApi = new LoginApi();
        let signInData: any = {tenantNo: tenantName, userName: userName, password: password};
        localStorage.setItem("loginMemorize", JSON.stringify({tenantName, userName}));

        try {
            let loginResponse = await loginApi.signIn(signInData);
            if (loginResponse.data.code != Api.CODE_OK) {
                setError("用户名/密码不正确");
            } else {
                let sessionService = SessionService.getInstance();
                sessionService.setAuthorization(loginResponse.data.data.token);
                sessionService.fireSessionChangeListeners();
            }
        } catch (e) {
            console.log(e);
            setError("用户名/密码不正确");
        }
    };



    // render
    return (
        <LoginWrapper>
            <LoginDialogWrapper>
                <LoginFormWrapper>
                    <TitleForm>
                        <LoginFormTitle>‌云融互联管理系统</LoginFormTitle>
                        <LoginFormTitleEn>Fusion Linker Admin System</LoginFormTitleEn>
                    </TitleForm>

                    <LoginForm>
                        <FormItemWrapper>
                            <Input 
                                size="large" 
                                placeholder="请输入用户编号/名称" 
                                value={tenantName} 
                                onChange={(e) => onTenantNameChange(e.target.value)} 
                                prefix={<BankOutlined style={{ color: '#BBBBBB', fontSize: '24px', marginRight: '10px' }} />} 
                            />
                        </FormItemWrapper>
                        <FormItemWrapper>
                            <Input 
                                size="large" 
                                placeholder="请输入登录名称/手机号/邮箱" 
                                value={userName} 
                                onChange={(e) => onUserNameChange(e.target.value)} 
                                prefix={<UserOutlined style={{ color: '#BBBBBB', fontSize: '24px', marginRight: '10px' }} />} 
                            />
                        </FormItemWrapper>
                        <FormItemWrapper>
                            <Input 
                                size="large" 
                                placeholder="请输入登录密码" 
                                type='password' 
                                style={{ letterSpacing: '3px' }} 
                                value={password} 
                                onChange={(e) => onPasswordChange(e.target.value)} 
                                onKeyDown={(e) => onPasswordKeyDown(e)} 
                                prefix={<KeyOutlined style={{ color: '#BBBBBB', fontSize: '24px', marginRight: '10px' }} />} />
                        </FormItemWrapper>

                        <ErrorMessage>{error}</ErrorMessage>
                        
                        <FormSubmit onClick={login}>
                            登录
                        </FormSubmit>
                    </LoginForm>
                </LoginFormWrapper>
            </LoginDialogWrapper>
        </LoginWrapper>
    );
}

export default Login;

